// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jqswmyqzmjdstetjqzvv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impxc3dteXF6bWpkc3RldGpxenZ2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyMzE2NTYsImV4cCI6MjA1MjgwNzY1Nn0.JLDD0eYGJ0G_8IL5BUR7NI6iEOQyNSMIxz4PLwSO0G4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);